import React from 'react';
import { Box, Tooltip } from '@material-ui/core';

interface FunnelItem {
  programId?: string;
  activityId?: string;
  activityRoleId?: string;
  name: string;
}

interface FunnelData {
  name: string;
  lockPrograms: boolean;
  lockActivities: boolean;
  lockRoles: boolean;
  programs: FunnelItem[];
  activities: FunnelItem[];
  activityRoles: FunnelItem[];
}

function FunnelIndicator({ label, locked, items }: { label: string; locked: boolean; items: FunnelItem[] }) {
  const count = items.length;
  const hasItems = count > 0;
  const mode = locked && hasItems ? 'locked' : hasItems ? 'limited' : 'none';

  const bgColor = mode === 'locked' ? '#e3f2fd' : mode === 'limited' ? '#fff3e0' : '#f5f5f5';
  const textColor = mode === 'locked' ? '#1976d2' : mode === 'limited' ? '#e65100' : '#bdbdbd';
  const badgeColor = mode === 'locked' ? '#1976d2' : '#e65100';
  const category = label === 'P' ? 'Programs' : label === 'A' ? 'Activities' : 'Roles';
  const modeLabel = mode === 'locked' ? 'Locked' : mode === 'limited' ? 'Limited' : 'Not set';

  const tooltipContent = hasItems
    ? `${category} (${modeLabel}): ${items.map((i) => i.name).join(', ')}`
    : `${category}: ${modeLabel}`;

  return (
    <Tooltip title={tooltipContent}>
      <span
        style={{
          position: 'relative',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: '20px',
          height: '20px',
          borderRadius: '4px',
          fontSize: '10px',
          fontWeight: 600,
          marginRight: '8px',
          backgroundColor: bgColor,
          color: textColor,
        }}
      >
        {label}
        {hasItems && (
          <span
            style={{
              position: 'absolute',
              top: '-5px',
              right: '-5px',
              backgroundColor: badgeColor,
              color: '#fff',
              borderRadius: '50%',
              width: '12px',
              height: '12px',
              fontSize: '8px',
              fontWeight: 700,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              lineHeight: 1,
            }}
          >
            {count}
          </span>
        )}
      </span>
    </Tooltip>
  );
}

const FunnelIndicators = ({ funnel }: { funnel: FunnelData }) => {
  return (
    <Box display='flex' alignItems='center'>
      <FunnelIndicator label='P' locked={funnel.lockPrograms} items={funnel.programs} />
      <FunnelIndicator label='A' locked={funnel.lockActivities} items={funnel.activities} />
      <FunnelIndicator label='R' locked={funnel.lockRoles} items={funnel.activityRoles} />
    </Box>
  );
};

export { FunnelIndicators };
